















































import BaseClose from '@/components/base/BaseClose.vue';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
    components: {
        BaseClose
    }
})
export default class BulkAddTasksConfirmationModal extends Vue {
    @Prop({ default: false }) value!: boolean;
    @Prop({ required: true }) taskTypeName!: string;
    @Prop({ required: true }) familyCount!: number;

    get isOpen(): boolean {
        return this.value;
    }

    set isOpen(val: boolean) {
        this.$emit('input', val);
    }

    private handleCancel() {
        this.$emit('cancel');
        this.isOpen = false;
    }

    private handleBegin() {
        this.$emit('begin');
        this.isOpen = false;
    }
}
